import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LangService {
  private readonly router: Router = inject(Router);
  private savedUrl: string = '';

  setUrl(url: string): void {
    this.savedUrl = url.startsWith('/') ? url : `/${url}`;
  }

  redirectToPage(): void {
    this.router.navigateByUrl(this.savedUrl);
  }
}
